export default __webpack_public_path__ + "static/media/DSC_5716.d77f85ef.jpg";